import { render } from "./ComponentRender.vue?vue&type=template&id=71c662ac"
import script from "./ComponentRender.vue?vue&type=script&lang=js"
export * from "./ComponentRender.vue?vue&type=script&lang=js"

import "./ComponentRender.vue?vue&type=style&index=0&id=71c662ac&lang=scss"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__